const Missing = () => {
  return (
    <div>
      <h1 className="title favorites__title">Missing 404</h1>
    </div>
  );
};

export default Missing;
